import { Link, useLocation } from 'react-router-dom'

import { isActivePath, type NavItem, type NavTree } from '@/app/registry'
import { Icon, type IconName } from '@/components/ui/Icon'
import { cn } from '@/lib/cn'

export const MORE_PATH = '/more'

function Tab({ to, label, icon, active }: { to: string; label: string; icon: IconName; active: boolean }) {
  return (
    <Link
      to={to}
      aria-current={active ? 'page' : undefined}
      className={cn(
        'flex min-h-14 min-w-0 flex-1 flex-col items-center justify-center gap-0.5 px-1 text-[11px] font-medium',
        active ? 'text-accent' : 'text-muted active:text-fg',
      )}
    >
      <Icon name={icon} size={22} strokeWidth={active ? 2 : 1.75} />
      <span className="max-w-full truncate">{label}</span>
    </Link>
  )
}

/** Нижняя панель телефона: до четырёх вкладок и «Ещё». */
export function BottomNav({ nav, className }: { nav: NavTree; className?: string }) {
  const { pathname } = useLocation()
  const activeTab = nav.tabs.find((t: NavItem) => isActivePath(t.path, pathname))
  const moreActive =
    !activeTab &&
    (pathname === MORE_PATH || nav.more.some((item) => isActivePath(item.path, pathname)))

  return (
    <nav
      aria-label="Нижнее меню"
      className={cn(
        'fixed inset-x-0 bottom-0 z-40 border-t border-border bg-surface/95 pb-[env(safe-area-inset-bottom)] backdrop-blur',
        className,
      )}
    >
      <div className="mx-auto flex max-w-xl">
        {nav.tabs.map((item) => (
          <Tab
            key={item.path}
            to={item.path}
            label={item.label}
            icon={item.icon}
            active={activeTab?.path === item.path}
          />
        ))}
        <Tab to={MORE_PATH} label="Ещё" icon="more" active={moreActive} />
      </div>
    </nav>
  )
}
